// components/Layout/DashboardLayout.js
import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import './Layout.css';

function DashboardLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const closeSidebar = () => setSidebarOpen(false);
  const toggleCollapse = () => setSidebarCollapsed(!sidebarCollapsed);

  return (
    <div className={`layout-container ${sidebarCollapsed ? 'sidebar-is-collapsed' : ''}`}>
      <Sidebar
        isOpen={sidebarOpen}
        closeSidebar={closeSidebar}
        isCollapsed={sidebarCollapsed}
        toggleCollapse={toggleCollapse}
      />

      {sidebarOpen && (
        <div className="sidebar-overlay" onClick={closeSidebar}></div>
      )}

      <div className="layout-main">
        <Topbar toggleSidebar={toggleSidebar} />
        <div className="layout-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default DashboardLayout;